import { defineMessages } from 'react-intl';

export default defineMessages({
  oldPasswordLabel: {
    id: 'features.changePassword.oldPasswordLabel',
    defaultMessage: 'Vecchia password',
    description: 'Label shown above the old password input field',
  },
  oldPasswordPlaceholder: {
    id: 'features.changePassword.oldPasswordPlaceholder',
    defaultMessage: 'Vecchia password',
    description: 'Placeholder of the old password input field',
  },
  newPasswordLabel: {
    id: 'features.changePassword.newPasswordLabel',
    defaultMessage: 'Nuova password',
    description: 'Label shown above the new password input field',
  },
  newPasswordPlaceholder: {
    id: 'features.changePassword.newPasswordPlaceholder',
    defaultMessage: 'Nuova password',
    description: 'Placeholder of the new password input field',
  },
  confirmPasswordLabel: {
    id: 'features.changePassword.confirmPasswordLabel',
    defaultMessage: 'Conferma nuova password',
    description: 'Label shown above the confirmation new password input field',
  },
  confirmPasswordPlaceholder: {
    id: 'features.changePassword.confirmPasswordPlaceholder',
    defaultMessage: 'Conferma nuova password',
    description: 'Placeholder of the confirmation new password input field',
  },
  changePasswordConfirmButton: {
    id: 'features.changePassword.changePasswordConfirmButton',
    defaultMessage: 'Conferma',
    description: 'Label of the change password button',
  },
  messageChangePasswordSuccess: {
    id: 'features.changePassword.messageChangePasswordSuccess',
    defaultMessage: 'Modifica password avvenuta con successo',
    description: 'Messagge change password success',
  },
  errorTitlePasswordAlreadyUsed: {
    id: 'features.changePassword.errorTitlePasswordAlreadyUsed',
    defaultMessage:
      'La password non può coincidere con una password precedentemente inserita',
    description: 'Error message for password already used',
  },
  errorTitleInvalidCredentials: {
    id: 'features.changePassword.errorTitleInvalidCredentials',
    defaultMessage: 'Password non corretta',
    description: 'Error message for password or username not valid',
  },
  errorTitleInvalidCriteria: {
    id: 'features.changePassword.errorTitleInvalidCriteria',
    defaultMessage: 'La password non soddisfa i criteri :',
    description: 'Error title for password format not valid',
  },
  errorDescriptionInvalidCriteria: {
    id: 'features.changePassword.errorDescriptionInvalidCriteria',
    defaultMessage:
      ' - Minimo 8 caratteri, \n - Non può contenere lo Username, \n - Deve contenere sia numeri che lettere, \n - Deve contenere almeno un carattere speciale o un carattere maiuscolo',
    description: 'Error description for password format not valid',
  },
  errorTitlePasswordNotMatching: {
    id: 'features.changePassword.errorTitlePasswordNotMatching',
    defaultMessage:
      'La nuova password scelta non coincide con quella indicata nel campo Conferma nuova password',
    description: 'Error title for password not matching confirmation',
  },
  errorTitleFillInAllFields: {
    id: 'features.changePassword.errorTitleFillInAllFields',
    defaultMessage: 'Compila tutti i campi',
    description: 'Error title fo fill in all fileds',
  },
  oldPasswordWrong: {
    id: 'features.changePassword.oldPasswordWrong',
    defaultMessage: 'La Vecchia password non è corretta',
    description: 'oldPasswordWrong',
  },
});
